import { Injectable } from '@angular/core';
import { VerificationSetAdmin } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VerificationSetAdminService {
    constructor(private http: HttpClient) {}

    public get(userId: string): Observable<VerificationSetAdmin> {
        return this.http.get<VerificationSetAdmin>(`api/verificationset/${userId}`);
    }

    public save(verificationSetAdmin: VerificationSetAdmin, userId: string): Observable<void> {
        return this.http.post<void>(`api/verificationset/${userId}`, verificationSetAdmin);
    }
}